import { Component, OnInit, Input } from '@angular/core';
import { VisibilityProvider } from "../../../shared/providers/visibility.provider";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder } from "@angular/forms";
import { AdminDataProvider } from '../../../shared/providers/master-provider/admin-data.provider';
import { ToastClientService } from "../../../../services/toast/toast-client.service";
import { VisibilityModel } from 'src/app/hubadmin/shared/models/visibility';

@Component({
  selector: 'app-visibility-list',
  templateUrl: './visibility-list.component.html',
  styleUrls: ['./visibility-list.component.scss']
})

export class VisibilityListComponent implements OnInit {

  @Input() model = new VisibilityModel;

  visibility:VisibilityModel[];
  formGroup;
  editProfileForm: FormGroup;
  // getPaginationCount;
  deletePopupUiData;

  constructor(
    public visibilityProvider: VisibilityProvider,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public adminDataProvider: AdminDataProvider,
    private router: Router,
    private toast: ToastClientService,
  ) { }


  ngOnInit() {

  }

  ngDoCheck() {
    this.visibility = this.visibilityProvider.visibility;
    if(typeof this.visibility !="undefined") {
      if(this.visibility.length > 0) {
        this.visibility = this.visibility.filter(i => i.element_type == 1);
      }
    }
  }

  deleteVisibility(targetModal, visibility) {
    this.deletePopupUiData = visibility.posm_audit_type;
    this.formGroup = this.fb.group({
      id: visibility.id,
      program_id: 1,
    });

    this.showVisibilityModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  showVisibilityModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }


  onSubmitVisibility(formData) {
      this.visibilityProvider.deleteVisibility(formData);
      this.modalService.dismissAll();
  }

  routeToConfigure(i){
    this.router.navigateByUrl('/hubAdmin/visibility-element-edit/' + i)
  }

}
